import React from 'react'
import cx from 'classnames'

import styles from './CoreButton.module.scss'
import { useTheme } from '../ThemeProvider/ThemeProvider'

const CoreButton = ({
  children,
  onClick,
  mode,
  loading,
  disabled,
  rounded,
  color,
  size,
  className,
  id,
  name,
  type,
  tabIndex,
  iconLeft,
  iconRight,
  selected,
  ...rest
}) => {
  const { themeMode } = useTheme()
  const buttonClass = cx([styles.button], [styles[color]], [styles[size]], [styles[themeMode]], className, {
    [styles.disabledButton]: disabled,
    [styles.outline]: mode === 'outline',
    [styles.contained]: mode === 'contained',
    [styles.text]: mode === 'text',
    [styles.primary]: mode === 'primary',
    [styles.danger]: mode === 'danger',
    [styles.warning]: mode === 'warning',
    [styles.selector]: mode === 'selector',
    [styles.dangerSexy]: mode === 'dangerSexy',
    [styles.link]: mode === 'link',
    [styles.loading]: loading,
    [styles.rounded]: rounded,
    [styles.selected]: selected
  })
  return (
    <button
      type={type || 'button'}
      className={buttonClass}
      disabled={disabled}
      onClick={onClick}
      id={id}
      name={name}
      tabIndex={tabIndex}
      {...rest}
    >
      {(iconLeft && !loading) && iconLeft}
      {children && (<span className={styles.childSelector}>{children}</span>)}
      {(iconRight && !loading) && iconRight}

    </button>
  )
}

CoreButton.defaultProps = {
  children: null,
  onClick: () => {},
  color: 'default',
  size: 'regular',
  mode: 'contained',
  rounded: false,
  loading: false,
  disabled: false,
  className: null,
  icon: null,
  id: null,
  name: null,
  tabIndex: null,
  type: 'button'
}
export default CoreButton
